import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  overTimeRequests: [],
  overTimeRequestsExport: [],
  overTimeRequest: {},
  commonProjects: [],
  totalOverTimeRequests: []
};

// getters
export const getters = {
  overTimeRequests: state => state.overTimeRequests,
  totalOverTimeRequests: state => state.totalOverTimeRequests,
  overTimeRequestsExport: state => state.overTimeRequestsExport,
  commonProjects: state => state.commonProjects,
  overTimeRequest: state => state.overTimeRequest,
  pagination: state => state.pagination
};

// mutations
export const mutations = {
  [types.OVERTIME_REQUEST.FETCH_OVERTIME_REQUEST](state, overTimeRequests) {
    state.overTimeRequests = overTimeRequests;
    state.pagination.from = overTimeRequests.from;
    state.pagination.to = overTimeRequests.to;
    state.pagination.totalPage = overTimeRequests.last_page;
    state.pagination.path = overTimeRequests.path;
    state.pagination.currentPage = overTimeRequests.current_page;
    state.pagination.totalRecord = overTimeRequests.total;
    state.pagination.perPage = overTimeRequests.per_page;
  },
  [types.OVERTIME_REQUEST.FETCH_TOTAL_OVERTIME_REQUEST](state, totalOverTimeRequests) {
    state.totalOverTimeRequests = totalOverTimeRequests;
  },
  [types.OVERTIME_REQUEST.FETCH_OVERTIME_REQUEST_EXPORT](
    state,
    overTimeRequests
  ) {
    state.overTimeRequestsExport = overTimeRequests;
  },
  [types.OVERTIME_REQUEST.SHOW_OVERTIME_REQUEST](state, overTimeRequest) {
    state.overTimeRequest = overTimeRequest;
  },
  [types.OVERTIME_REQUEST.COMMON_PROJECT](state, commonProjects) {
    state.commonProjects = commonProjects;
  }
};

// actions
export const actions = {
  async listOverTimeRequest({ commit }, payload) {
    const response = await axios.get(api.LIST_OVERTIME_REQUEST, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        employee_info: payload.employeeInfo,
        position_id: payload.positionId,
        division_code: payload.divisionCode,
        start_date: payload.start_date,
        end_date: payload.end_date,
        project_id: payload.projectId,
        approve_person: payload.approvePerson,
        status: payload.status
      }
    });
    commit(
      types.OVERTIME_REQUEST.FETCH_OVERTIME_REQUEST,
      response.data.overTimeRequests
    );
    commit(
      types.OVERTIME_REQUEST.FETCH_TOTAL_OVERTIME_REQUEST,
      response.data.totalOverTimeRequests
    );
    commit(types.OVERTIME_REQUEST.COMMON_PROJECT, response.data.commonProjects);
  },

  async listOverTimeRequestExport({ commit }, payload) {
    const response = await axios.get(api.LIST_OVERTIME_REQUEST, {
      params: {
        employee_info: payload.employeeInfo,
        position_id: payload.positionId,
        division_code: payload.divisionCode,
        start_date: payload.start_date,
        end_date: payload.end_date,
        project_id: payload.projectId,
        approve_person: payload.approvePerson,
        status: payload.status,
        export: payload.export
      }
    });
    commit(
      types.OVERTIME_REQUEST.FETCH_OVERTIME_REQUEST_EXPORT,
      response.data.overTimeRequests
    );
  },

  async detailOverTimeRequest({ commit }, overTimeRequestId) {
    const response = await axios.get(
      api.SHOW_OVERTIME_REQUEST + "/" + overTimeRequestId
    );
    commit(types.OVERTIME_REQUEST.SHOW_OVERTIME_REQUEST, response.data);
  }
};
